const Dashboard = () => import(/* webpackChunkName: "page-hello-world" */ '@/components/BigScreen')
const Personalpage = () => import('@/components/PersonalPage')
const Enterprisepage = () => import('@/components/EnterprisePage')
const Otherpage = () => import('@/components/OtherPage')
const Serviceprovider = () => import('@/components/ServiceProvider')
const CJYThreePage = () => import('@/components/CJYThreePage')
const YHPage = () => import('@/components/YHPage')
const ZFJGPage = () => import('@/components/ZFJGPage')
const DITwoPage = () => import('@/components/DITwoPage')
const BankPage = () => import('@/components/BankPage')
const BondCompanyPage = () => import('@/components/BondCompanyPage')
const CzcgPage = () => import('@/components/CzcgPage')
const CzcgPageNew = () => import('@/components/CzcgPage_new')
const BigScreenAdminNew = () => import('@/components/BigScreen_admin_new')
const CJYThreePageNew = () => import('@/components/CJYThreePage_new')
const YHPageNew = () => import('@/components/YHPage_new')
const ZFJGPageNew = () => import('@/components/ZFJGPage_new')

export default [
  {
    path: '/dashboard',
    name: 'dashboard',
    component: BigScreenAdminNew,
    // component: BigScreenAdminNew,
    meta: {
      title: '首页',

    },
  },
  {
    path: '/personalpage',
    name: 'personalpage',
    component: Personalpage,
    meta: {
      title: '首页',

    },
  },

  {
    path: '/enterprisepage',
    name: 'enterprisepage',
    component: Enterprisepage,
    meta: {
      title: '首页',

    },
  },

  {
    path: '/otherpage',
    name: 'otherpage',
    component: Otherpage,
    meta: {
      title: '首页',

    },
  },
  {
    path: '/serviceprovider',
    name: 'serviceprovider',
    component: Serviceprovider,
    meta: {
      title: '首页',

    },
  },
  {
    path: '/cjythreepage',
    name: 'cjythreepage',
    component: CJYThreePage,
    // component: CJYThreePageNew,
    meta: {
      title: '首页',

    },
  },
  {
    path: '/ditwopage',
    name: 'ditwopage',
    component: DITwoPage,
    meta: {
      title: '首页',

    },
  },
  {
    path: '/bankpage',
    name: 'bankpage',
    component: BankPage,
    meta: {
      title: '首页',

    },
  },
  {
    path: '/YHPage',
    name: 'YHPage',
    component: YHPage,
    // component: YHPageNew,
    meta: {
      title: '首页',

    },
  },
  {
    path: '/BondCompanyPage',
    name: 'BondCompanyPage',
    component: BondCompanyPage,
    meta: {
      title: '首页',

    },
  },
  {
    path: '/ZFJGPage',
    name: 'ZFJGPage',
    // component: ZFJGPageNew,
    component: ZFJGPage,
    meta: {
      title: '首页',

    },
  },
  {
    path: '/czcgpage',
    name: 'czcgpage',
    // component: CzcgPageNew,
    component: CzcgPage,
    meta: {
      title: '首页',

    },
  },
  {
    path: '/sspy',
    name: 'sspy',
    component: () => import('@/components/BigScreenComponents/sspy/index'),
    meta: {
      title: '上市培育',
      isBlack: false,
      fullscreen: true,
      needLogin: false,
    },
  },

]
